module.exports = __webpack_public_path__ + "img/loading-quote-img-7.b9cfb02f.png";